import { useState, useEffect, useRef } from 'react';
import { useEstadoApp } from '../context/EstadoAppContext';

export function Tabs({ items, rightContent, onTabChange, defaultActiveTab }) {
	const { estadoAppX } = useEstadoApp();
	const [activeTabId, setActiveTabId] = useState(defaultActiveTab || items[0]?.id || null);
	const tabInitializedRef = useRef(false);
	console.log("TAB ACTIVO", activeTabId )

	// Encuentra el item activo para renderizar su contenido
    const activeItem = items.find(item => item.id === activeTabId);

	useEffect(() => {
		console.log('Tab activo actualizado:', {
			activeTabId,
			defaultActiveTab,
			items: items.map(i => i.id)
		});
	}, [activeTabId, defaultActiveTab, items]);

	// Efecto para manejar cambios en defaultActiveTab
    useEffect(() => {
        if (defaultActiveTab && defaultActiveTab !== activeTabId) {
			console.log('Actualizando tab activo a:', defaultActiveTab);
            setActiveTabId(defaultActiveTab);
        }
    }, [defaultActiveTab]);
	
	// Efecto para notificar cambios en activeItem
	useEffect(() => {
		if (activeItem && onTabChange) {
			onTabChange(activeItem);
		}
	}, [activeItem, onTabChange]);

	useEffect(()=>{ 
		// si estadoAppX es 'inicial' o 'nuevo_etapa2', activar la pestaña tab1 (solo una vez)
		if((estadoAppX === 'inicial' || estadoAppX === 'nuevo_etapa2') && !tabInitializedRef.current) {
			tabInitializedRef.current = true;
			setActiveTabId('tab1');
		}
		// Resetear el ref cuando el estado cambia a otro valor diferente
		if(estadoAppX !== 'inicial' && estadoAppX !== 'nuevo_etapa2') {
			tabInitializedRef.current = false;
		}
	}, [estadoAppX])

	return (
		<div className="dark:bg-gray-900 dark:text-gray-100 p-4 rounded-lg">
			<div className="flex justify-between items-center border-b dark:border-gray-600 pb-2">
				{/*<div className="flex space-x-1">
					{items.map((tab) => (
						<button
							key={tab.id}
							className={`px-4 py-2 text-sm font-medium transition-colors duration-200 ${
								tab.id === activeTabId
									? 'text-teal-600 border-b-2 border-teal-500 dark:text-teal-400 dark:border-teal-400'
									: 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
							}`}
							onClick={() => setActiveTabId(tab.id)}
						>
							{tab.label}
						</button>
					))}
				</div>*/}
				<nav className="-mb-px flex space-x-8" aria-label="Tabs">
                    {items.map((item) => (
                        <button
                            key={item.id}
                            onClick={() => setActiveTabId(item.id)}
                            className={`
                                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                                ${activeTabId === item.id
                                    ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 hover:border-gray-300 dark:hover:text-gray-200 dark:hover:border-gray-500'
                                }
                            `}
                        >
                            {item.label}
                        </button>
                    ))}
                </nav>
				{rightContent && (
					<div className="pr-2">
						{rightContent}
					</div>
				)}

			</div>

			{/* Contenido de la pestaña activa */}
			{/*<div className="mt-4 p-1 dark:bg-gray-900">
				{items.map((tab) => (
					<div
						key={tab.id}
						className={tab.id === activeTabId ? 'block' : 'hidden'}
					>
						{tab.content}
						{tab.form}
					</div>
				))}
			</div>*/}
			{/* Contenedor del contenido (solo se renderiza el del tab activo) */}
            <div className="mt-4">
                {activeItem && activeItem.form}
            </div>
		</div>
	);
}

//quitar 30-enero-2025 - el contenido se volvia a renderizar
/*
{items.find(tab => tab.id === activeTabId)?.content}
        <div>{items.find(tab => tab.id === activeTabId)?.form}</div>
*/


//quitar 29-enero-2025
//<p>{items[activeTabIndex].content}</p>

/*
return (
    <>
      <div>
        <div className="flex space-x-3 border-b">
          {items.map((tab) => { //idx

            //const key = tab.id;

            return (
              <button
                role="tab"
                aria-selected={idx === activeTabIndex}
                key={idx}
                className={`py-2 border-b-4 transition-colors duration-300 
                    ${idx === activeTabIndex ? 'border-teal-500 focus:text-white' : 'border-transparent hover:border-gray-200'
                  }`}
                // Change the active tab on click.
                onClick={() => setActiveTabIndex(idx)}
              >
                {tab.label}
              </button>
            );

          })}
        </div>
        <div className="py-4  border-solid border-4 border-gray-200">
          
          <div>{items[activeTabIndex].form}</div>
        </div>
      </div>
    </>
  );
*/